module.exports = __webpack_public_path__ + "static/media/remove_device.42a0c20d.svg";